import { render, staticRenderFns } from "./DailyAscentsPart.vue?vue&type=template&id=4e0b239a&scoped=true"
import script from "./DailyAscentsPart.vue?vue&type=script&lang=js"
export * from "./DailyAscentsPart.vue?vue&type=script&lang=js"
import style0 from "./DailyAscentsPart.vue?vue&type=style&index=0&id=4e0b239a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b239a",
  null
  
)

export default component.exports